<svelte:options tag={null} />
<script>
  import { 
    onMount,
    tick,
    get_current_component
  } from "svelte/internal";
  import "@everymatrix/em-accordion";
  import '@everymatrix/retail-modal';

  export let limit = null;
  export let isedit = false;
  export let isloading = false;
  let isModal = false;

  let periods = [
    'CoolOffFor24Hours', 
    'CoolOffFor7Days', 
    'CoolOffFor30Days',
    'CoolOffFor3Months'
  ];

  let coolOffPeriod = '';
  let coolOffExpiryDate = '';

  const textRegex =  /[A-Z][a-z]+|[0-9]+/g;
  const thisComponent = get_current_component();

  const dispatchWcEvent = (name, detail) => {
    thisComponent.dispatchEvent(
      new CustomEvent(name, {
        detail,
        composed: true, // propagate across the shadow DOM
      })
    );
  };

  String.prototype.lowerFirstLetter = function() {
    return this.charAt(0).toLowerCase() + this.slice(1);
  }

  function formatDate(date) {
    if (date === '') {
      return '';
    } else {
      let format = new Date(date).toISOString();
      return format;
    }
  }

  const initModal = (type) => {
    if(type !== 'CoolOff') {
      window.postMessage({ type: "AddCoolOffModal" }, "*");
      isModal = true;
    } else {
      handleDelete(limit.type.lowerFirstLetter());
    }
  }

  const handleDelete = (type) => {
    let endpoint;

    if (type === 'selfExclusion') {
      endpoint = `limits/selfExclusion?coolOffPeriod=${coolOffPeriod}`;
    }

    if (type === 'selfExclusion' && coolOffPeriod === 'CoolOffUntilSelectedDate') {
      endpoint = `limits/selfExclusion?coolOffPeriod=${coolOffPeriod}?coolOffUntilSelectedDate=${formatDate(coolOffExpiryDate)}`;
    }

    if (type === 'coolOff') {
      endpoint = `limits/coolOff`;
    }
    // Send Custom Event
    dispatchWcEvent("delete", { endpoint, limit: 'exculsion' });
  };

  const handleEvents = (e) => {
    // Set Cool Off
    e.data?.type === "AddCoolOffModalConfirm" && 
      handleDelete(limit.type.lowerFirstLetter())
    ;
  };
  
  onMount(() => {
    window.addEventListener("message", handleEvents);
    return () => {
      window.removeEventListener("message", handleEvents);
    }
  });
</script>

{#if limit}
  <div class="activeLimit">
    <div class="activeLimit__title">
      {#if isedit}
        <button 
          class="activeLimit__delete"
          on:click={() => initModal(limit.type)}
        >
          {#if isloading}
            <div class="sk-chase">
              <div class="sk-chase-dot"></div>
              <div class="sk-chase-dot"></div>
              <div class="sk-chase-dot"></div>
              <div class="sk-chase-dot"></div>
              <div class="sk-chase-dot"></div>
              <div class="sk-chase-dot"></div>
            </div>
          {:else}
            <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd"></path>
            </svg>
          {/if}
        </button>
      {/if}
      {limit.type.match(textRegex).join(" ")}
    </div>
    <div class="activeLimit__content" 
      class:modified={limit.isModified}
    >
      <!-- Period -->
      <div class="activeLimit__limit">
        <strong>Period:</strong>
        {limit.period.match(textRegex).join(" ")}
      </div>
      <!-- Expiry Date -->
      {#if limit.expiryDate}
        <div class="activeLimit__limit">
          <strong>Expiry Date:</strong>
          {limit.expiryDate}
        </div>
      {/if}
      <!-- Notification -->
      <div class="activeLimit__limit">
        <strong>Notification Email:</strong>
        {limit.allowNewsEmail}
      </div>
      <!-- Reason -->
      {#if limit.selfExclusionReason}
      <div class="activeLimit__limit">
        <strong>Reason:</strong>
        {limit.selfExclusionReason}
      </div>
      {/if}
    </div>
  </div>
{/if}

<!-- Cool Off Modal -->
{#if isModal}
  <retail-modal 
    modalname="AddCoolOffModal" 
    modaltype="confirm" 
    hasclose="false"
  >
    <!-- NOTE: Does it need an icon ? -->
    <header class="modalHeader">
      <svg 
        style="width: 60px; height: 60px;"
        fill="currentColor" 
        viewBox="0 0 20 20" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z"></path><path fill-rule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z" clip-rule="evenodd"></path>
      </svg>
    </header>
    <!-- Modal Content -->
    <div class="modalContent">
      <ul class="coolOff">
        <li>
          <label>
            <input
              class="radio"
              type=radio
              bind:group={coolOffPeriod}
              value="CoolOffNone"
            />
            <span>
              Cool Off None
            </span>
          </label>
        </li>
        {#each periods as period}
          <li>
            <label>
              <input
                class="radio"
                type=radio
                bind:group={coolOffPeriod}
                value="{period}"
              />
              <span>
                {period.match(textRegex).join(" ")}
              </span>
            </label>
          </li>
        {/each}
      </ul>

      <div class="coolOff__date">
        <label class="selectWrapper">
          <input
            class="radio"
            type=radio
            bind:group={coolOffPeriod}
            value="CoolOffUntilSelectedDate"
          />
          <span>
            Cool Off Until Selected Date
          </span>
        </label>
        <!-- Cool Off Period Date -->
        {#if coolOffPeriod === 'CoolOffUntilSelectedDate'}
          <label class="inputWrapper">
            <input
              class="input"
              type="date"
              bind:value="{coolOffExpiryDate}"
            >
          </label>
        {/if}
      </div>
    </div>
  </retail-modal>
{/if}

<style lang="scss">
  *,
  *::before,
  *::after {
    margin: 0;
    padding: 0;
    list-style: none;
    outline: none;
    text-decoration: none;
    box-sizing: border-box;
    font-family: "Helvetica Neue", "Helvetica", sans-serif;
  }

  // Active limit: NOTE: Style this
  .activeLimit {
    margin-bottom: 15px;

    &__title {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      font-size: 14px;
      font-weight: bold;
    }

    &__limit {
      display: grid;
      grid-template-columns: auto auto auto 1fr;
      gap: 5px;
      margin-bottom: 5px;
      padding-left: 5px;
      border-left: 5px solid gray;
      align-items: center;
      font-size: 14px;
      &:last-child { margin-bottom: 0; }
    }

    &__content {
      display: flex;
      flex-flow: column nowrap;
      align-items: flex-start;
      margin-bottom: 5px;
      &:last-child { margin-bottom: 0; }

      strong { font-size: 12px; }

      &.modified {
        padding-left: 5px;
        border-left: 4px solid green;
      }
    }

    &__delete {
      width: 25px;
      height: 25px;
      margin-right: 5px;
      padding: 5px;
      border: none;
      border-radius: 50%;
      cursor: pointer;
      svg { fill: #868686; }
      &:hover {
        svg { fill: #ec7777; }
      }
    }
  }

  // Modal Styling
  .modalContent {
    margin-top: 20px;
  }

  .coolOff {
    li {
      margin-bottom: 15px;
    }

    &__date .inputWrapper {
      display: flex;
      margin-top: 15px;
    }
  }

  .sk-chase {
    width: 10px;
    height: 10px;
    position: relative;
    left: 2px;
    top: 2px;
    animation: sk-chase 2.5s infinite linear both;
  }

  .sk-chase-dot {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0; 
    animation: sk-chase-dot 2.0s infinite ease-in-out both; 
  }

  .sk-chase-dot:before {
    content: '';
    display: block;
    width: 25%;
    height: 25%;
    background-color: green;
    border-radius: 100%;
    animation: sk-chase-dot-before 2.0s infinite ease-in-out both; 
  }

  .sk-chase-dot:nth-child(1) { animation-delay: -1.1s; }
  .sk-chase-dot:nth-child(2) { animation-delay: -1.0s; }
  .sk-chase-dot:nth-child(3) { animation-delay: -0.9s; }
  .sk-chase-dot:nth-child(4) { animation-delay: -0.8s; }
  .sk-chase-dot:nth-child(5) { animation-delay: -0.7s; }
  .sk-chase-dot:nth-child(6) { animation-delay: -0.6s; }
  .sk-chase-dot:nth-child(1):before { animation-delay: -1.1s; }
  .sk-chase-dot:nth-child(2):before { animation-delay: -1.0s; }
  .sk-chase-dot:nth-child(3):before { animation-delay: -0.9s; }
  .sk-chase-dot:nth-child(4):before { animation-delay: -0.8s; }
  .sk-chase-dot:nth-child(5):before { animation-delay: -0.7s; }
  .sk-chase-dot:nth-child(6):before { animation-delay: -0.6s; }

  @keyframes sk-chase {
    100% { transform: rotate(360deg); } 
  }

  @keyframes sk-chase-dot {
    80%, 100% { transform: rotate(360deg); } 
  }

  @keyframes sk-chase-dot-before {
    50% {
      transform: scale(0.4); 
    } 100%, 0% {
      transform: scale(1.0); 
    } 
  }
</style>
